// RadioWrapper.tsx
import { RadioProps as MuiRadioProps } from '@mui/material';
import clsx from 'clsx';
import {
  InputControlLabelProps,
  InputControlWithLabel
} from '../input-control-with-label/InputControlWithLabel';
import { Radio } from './Radio';

export interface RadioWrapperProps extends Omit<InputControlLabelProps, 'control'> {
  radioProps: MuiRadioProps;
  variant?: 'default' | 'outline';
  description?: string;
  isActive?: boolean;
  activeClassName?: string;
  wrapperClassName?: string;
}

export function RadioWrapper(props: RadioWrapperProps) {
  const {
    dataId,
    disabled,
    radioProps,
    variant = 'default',
    description,
    isActive,
    activeClassName,
    wrapperClassName,
    ...inputControlLabelProps
  } = props;

  const radioControl = (
    <InputControlWithLabel
      dataId={dataId}
      disabled={disabled}
      {...inputControlLabelProps}
      control={
        <Radio
          id={dataId}
          dataId={dataId}
          disabled={disabled}
          style={{ marginTop: '2px' }}
          {...radioProps}
        />
      }
    />
  );

  if (variant === 'default') {
    return radioControl;
  }

  return (
    <div
      className={clsx(wrapperClassName, isActive && activeClassName)}
      data-id={`${dataId}-outer-container`}
    >
      {radioControl}
      {description && (
        <span
          data-id={`${dataId}-description`}
          className={clsx('p-2', isActive ? 'text-default' : 'text-secondary')}
        >
          {description}
        </span>
      )}
    </div>
  );
}
